import { AuxiliaryEngineTypeBM } from '../../types/BusinessModel/Vessel/AuxiliaryEngineTypeBM';
import { AuxiliaryEngineType } from '../../types/ViewModel/Vessel/AuxiliaryEngineType';
import { AuxiliaryEngineMakerFactory } from './AuxiliaryEngineMakerFactory';

export class AuxiliaryEngineTypeFactory {
    private auxiliaryEngineMakerFactory = new AuxiliaryEngineMakerFactory();

    public create(data: AuxiliaryEngineTypeBM): AuxiliaryEngineType | undefined {
        if (!data) return;
        return new AuxiliaryEngineType(
            data.id,
            data.type,
            data.makerId,
            this.auxiliaryEngineMakerFactory.create(data.maker),
            data.kwMaxLoad,
            data.canUseHfo
        );
    }
}
